// Reusable form field component with standardized label and optional helper text
// Provides consistent styling for form fields across modals and forms
// CREATED: Typography standardization - field labels in forms

import { TYPOGRAPHY } from '../../lib/designSystem';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  htmlFor?: string;
  helperText?: string;
  errorText?: string;
  optional?: boolean;
  className?: string;
}

export function FormField({
  label,
  children,
  htmlFor,
  helperText,
  errorText,
  optional = false,
  className = ''
}: FormFieldProps) {
  return (
    <div className={className}>
      <label
        htmlFor={htmlFor}
        className={`block ${optional ? TYPOGRAPHY.fieldLabelOptional : TYPOGRAPHY.fieldLabel} mb-2`}
      >
        {label}
        {optional && <span className="ml-1 text-gray-400">(optionnel)</span>}
      </label>
      {children}
      {helperText && !errorText && (
        <p className={`${TYPOGRAPHY.helperText} mt-1.5`}>
          {helperText}
        </p>
      )}
      {errorText && (
        <p className={`${TYPOGRAPHY.errorText} mt-1.5`}>
          {errorText}
        </p>
      )}
    </div>
  );
}
